export default __webpack_public_path__ + "static/media/nav-exit-outer.611a8cdb.png";